import { globalpermissions } from '../../../Services/Permission.js';

export const TEMPLATE_PERMISSIONS = {
  pageAccess: globalpermissions?.pagePermissions?.templateDashboardNew,
  addTemplates: globalpermissions?.templateDashboard?.addTemplates,
  editTemplates: globalpermissions?.templateDashboard?.editTemplates,
  deleteTemplates: globalpermissions?.templateDashboard?.deleteTemplates,
  optinUsers: globalpermissions?.templateDashboard?.optinUsers,
  wabaAppList: globalpermissions?.templateDashboard?.wabaAppList,
  metaEmbeddedSignup: globalpermissions?.templateDashboard?.metaEmbeddedSignup,
  b2bFormPageAccess: globalpermissions?.pagePermissions?.b2bFormPageAccess,
};
